import './LoadingComponent.scss'
import Image from 'react-bootstrap/Image';
import awLogo from './../../utils/resources/awayter_connect_light_cropped.png'
import { Spinner } from 'react-bootstrap';


const LoadingComponent = () => {

    return (
        <div className='text-center containerLoading'>
            <div className='text-center loadingImgContainer p-5'>
                <Image src={awLogo} className='img-fluid mb-2 logoSize' />
                <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div>
            </div>
        </div>
    )
}

export default LoadingComponent